import { url } from "../config";

export const api = ({ data, link }) => {
    return fetch(`${ url }/${ link }`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};